/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo5 from "../assets/img/logo5.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo5} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/company/altruistedigital/">
                <img src={navIcon1} alt="Icon" />
              </a>
              <a href="#">
                <img src={navIcon2} alt="Icon" />
              </a>
              <a href="https://www.instagram.com/altruiste">
                <img src={navIcon3} alt="Icon" />
              </a>
            </div>
            <p>
              Copyright <b>2023.</b> All Rights Reserved
            </p>
            <p>
              Designed & Developed by <b>Altruiste.</b>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
